'use client'

export const getData = (key) => {
  return localStorage?.getItem(key)
}

export const setData = (key, value) => {
  return localStorage.setItem(key, value)
}

export const clearData = (key) => {
  return localStorage.removeItem(key)
}

export const setCookie = async (obj) => {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/cookie/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
  return res
}

export const clearCookie = async (key, ctx = null) => {
  await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/cookie/delete?cookieName=${key}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
}

export const getFormattedDate = (date) => {
  const dateObj = new Date(date)
  const dd = dateObj.toLocaleString('en', { day: 'numeric' })
  const mm = dateObj.toLocaleString('en', { month: 'long' })
  const yy = dateObj.toLocaleString('en', { year: 'numeric' })

  return `${dd} ${mm} ${yy}`
}

export const isObject = (val) =>
  Boolean(val && typeof val === 'object' && !Array.isArray(val))
